const normalizePieveProjectPendingMutation = ({ payload, mutation } = {}) => {
  const requestId = String(payload?.requestId || payload?.meta?.requestId || '').trim();
  const normalizedMutation = String(mutation || '')
    .trim()
    .toLowerCase();

  if (!requestId || !normalizedMutation) {
    return null;
  }

  return {
    requestId,
    mutation: normalizedMutation,
    payload
  };
};

export default normalizePieveProjectPendingMutation;
